import { Dispatch, SetStateAction, useState } from 'react'
import { DistributionListProps } from '../models/new-resource'

export interface DistributionAction {
    distributionModel: DistributionListProps
    setDistributionModel: Dispatch<SetStateAction<DistributionListProps>>
    storesToImport: string[]
    setStoresToImport: Dispatch<SetStateAction<string[]>>
    storesToExport: string[]
    setStoresToExport: Dispatch<SetStateAction<string[]>>
    showDialogDownloadList: boolean
    setShowDialogDownloadList: Dispatch<SetStateAction<boolean>>
    showDialogExportTemplate: boolean
    setShowDialogExportTemplate: Dispatch<SetStateAction<boolean>>
    showDialogUploadList: boolean
    setShowDialogUploadList: Dispatch<SetStateAction<boolean>>
}

const initDistributionModel = {
    listName: {
        value: '',
    },
    selectedStoreList: {
        value: [],
        mandatory: true,
    },
    selectedDistributionList: {
        value: [],
    },
}

const useDistributionAction = (): DistributionAction[] => {
    const [distributionModel, setDistributionModel] =
        useState<DistributionListProps>(initDistributionModel)

    const [storesToImport, setStoresToImport] = useState<any[]>([])
    const [storesToExport, setStoresToExport] = useState<any[]>([])

    const [showDialogUploadList, setShowDialogUploadList] = useState<boolean>(false)
    const [showDialogDownloadList, setShowDialogDownloadList] = useState<boolean>(false)
    const [showDialogExportTemplate, setShowDialogExportTemplate] = useState<boolean>(false)

    return [
        {
            distributionModel,
            setDistributionModel,
            storesToImport,
            setStoresToImport,
            storesToExport,
            setStoresToExport,
            showDialogDownloadList,
            setShowDialogDownloadList,
            showDialogExportTemplate,
            setShowDialogExportTemplate,
            showDialogUploadList,
            setShowDialogUploadList,
        },
    ]
}

export default useDistributionAction
